<template>
  <div class="app-container Srctwo">
    <!-- <iframe class="frame_page" v-show="mapVisible" id="contentPad"
            ref="mapFrame"
            src="http://117.80.118.137:8888/App_Html/Page/Index.html"> -->
    <!--            src="https://lfczhxc.com/gis/App_Html/Page/Index.html">
    </iframe>-->
    <ScreenMap
      class="screenMapBox"
      ref="mapBox"
      :zoom="15.5"
      style="width: 100%; height: 100%"
    />
    <div class="left_pad" v-show="!mapVisible">
      <div class="first_pad" style="height: 58%; z-index: 500">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">党建统计</span>
        </div>
        <div class="float_num" style="top: 12%">
          <div class="float_num_item">
            <img
              src="../../assets/satistics/icon-num7.png"
              alt=""
              class="float_num_icon"
            />
            <div style="margin-left: 10px">
              <div class="float_num_text" style="color: #19e8ff">
                {{ peopleNum.dangzhibuNumber }}
              </div>

              <div class="float_num_title">党支部数量</div>
            </div>
          </div>
          <div class="float_num_item">
            <img
              src="../../assets/satistics/icon-num7.png"
              alt=""
              class="float_num_icon"
            />
            <div style="margin-left: 10px">
              <div class="float_num_text" style="color: #ffbf2e">
                {{ peopleNum.partyMemberTotal - 1 }}
              </div>

              <div class="float_num_title">党员数量(人)</div>
            </div>
          </div>
        </div>
        <div class="pad_title" style="top: 30%">
          <span class="pad_title_text selected_title">人户统计</span>
        </div>
        <div class="float_num" style="top: 37%">
          <div class="float_num_item">
            <img
              src="../../assets/satistics/icon-num4.png"
              alt=""
              class="float_num_icon"
            />
            <div style="margin-left: 10px">
              <div class="float_num_text" style="color: #19e8ff">
                {{ placeNum.householdTotal }}
              </div>
              <div class="float_num_title">出租屋数量(间)</div>
            </div>
          </div>
          <div class="float_num_item">
            <img
              src="../../assets/satistics/icon-num5.png"
              alt=""
              class="float_num_icon"
            />
            <div style="margin-left: 10px">
              <div class="float_num_text" style="color: #ffffff">6842</div>
              <!-- {{peopleNum.peopleResidenceTotal}} -->

              <div class="float_num_title">户籍人口(人)</div>
            </div>
          </div>
          <div class="float_num_item">
            <img
              src="../../assets/satistics/icon-num6.png"
              alt=""
              class="float_num_icon"
            />
            <div style="margin-left: 10px">
              <div class="float_num_text" style="color: #19e8ff">
                {{ peopleNum.zhuhuTotal }}
              </div>

              <div class="float_num_title">住户数量(户)</div>
            </div>
          </div>
        </div>

        <div class="pad_title1" style="top: 55%">
          <span class="pad_title_text selected_title">企寺统计</span>
        </div>

        <div class="float_num1" style="top: 62%">
          <div class="float_num_item">
            <div class="float_num_text" style="color: #19e8ff">301</div>
            <!-- {{ placeNum.companyTotal }} -->
            <img
              src="@/assets/satistics/icon-num1.png"
              alt=""
              class="float_num_icon"
            />
            <div class="float_num_title">企业数量(家)</div>
          </div>
          <div class="float_num_item">
            <div class="float_num_text" style="color: #ffbf2e">
              {{ placeNum.temple }}
            </div>
            <img
              src="@/assets/satistics/icon-num2.png"
              alt=""
              class="float_num_icon"
            />
            <div class="float_num_title">宗教场所及民间信仰点数量(家)</div>
          </div>
          <div class="float_num_item">
            <div class="float_num_text" style="color: #ffffff">
              {{ placeNum.businessPlaceTotal }}
            </div>
            <img
              src="@/assets/satistics/icon-num3.png"
              alt=""
              class="float_num_icon"
            />
            <div class="float_num_title">9+1场所数量(家)</div>
          </div>
        </div>

        <!-- <div class="mapBox">
          <ScreenMap ref="mapBox" style="width: 100%; height: 100%" />
        </div> -->
      </div>
      <div class="first_pad" style="height: 38%">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">331巡查</span>
        </div>
        <div class="top_right">
          <el-select
            v-model="checkType"
            @change="getThreeOneData"
            clearable
            placeholder="巡查类型"
            class="xalachoose"
            :popper-append-to-body="false"
          >
            <el-option :value="1" label="出租屋巡查"></el-option>
            <el-option :value="2" label="9+1巡查信息"></el-option>
            <el-option :value="3" label="企业安全生产巡查"></el-option>
          </el-select>
          <el-select
            v-model="statusType"
            placeholder="状态"
            class="xalachoose"
            @change="getThreeOneData"
            clearable
            :popper-append-to-body="false"
          >
            <el-option :value="0" label="正常"></el-option>
            <el-option :value="1" label="待整改"></el-option>
            <el-option :value="2" label="已整改"></el-option>
          </el-select>
          <!-- <span class="more_button">更多</span> -->
        </div>
        <div
          style="
            height: 80%;
            width: 90%;
            position: absolute;
            top: 55%;
            left: 50%;
            transform: translate(-50%, -50%);
          "
        >
          <el-carousel
            arrow="never"
            direction="vertical"
            style="height: 100%"
            height="100%"
            indicator-position="none"
            :interval="3000"
            autoplay
            loop
          >
            <!--                     indicator-position="none">-->
            <el-carousel-item v-for="(list, index) in orderList" :key="index">
              <div
                class="gd_list_item"
                v-for="(item, index1) in list"
                :key="index1"
                @click="handleView(item)"
              >
                <div class="gd_list_item_line">
                  <div class="gd_list_item_type">
                    <span
                      :style="{
                        background: ordertabcolor[item.ordercolorindex],
                      }"
                      >{{ item.typeName }}</span
                    >
                  </div>
                  <div class="gd_list_item_time">
                    {{ item.createdDate }}
                  </div>
                </div>
                <div class="gd_list_item_content">
                  <div class="gd_list_item_title">{{ item.content }}</div>
                  <div
                    class="gd_list_item_status"
                    :style="{
                      color: [
                        item.statusName == '已整改'
                          ? 'rgba(0, 255, 160, 1)'
                          : item.statusName == '正常'
                          ? 'rgba(0, 255, 160, 1)'
                          : 'rgba(255, 165, 0, 1)',
                      ],
                    }"
                  >
                    {{ item.statusName }}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
    </div>
    <!-- <div class="center_pad" v-show="!mapVisible"></div> -->
    <div class="right_pad" v-show="!mapVisible">
      <div class="first_pad first_pad2" style="height: 34%">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">产值税收(万)</span>
        </div>
        <div class="content_area">
          <div class="tax_line">
            <div class="tax_icon">
              <img
                src="../../assets/satistics/icon-thisyear.png"
                alt=""
                class="tax_icon_img"
              />
              <span class="tax_icon_text">上一年度</span>
            </div>
            <div class="tax_item">
              <div class="tax_num" style="color: #2effff">
                {{ Number(taxInfo.lastOutput).toFixed(2) || 0 }}
              </div>
              <div class="tax_title">¥总产值</div>
            </div>
            <div class="tax_item">
              <div class="tax_num" style="color: #2effff">
                {{ Number(taxInfo.lastTax).toFixed(2) || 0 }}
              </div>
              <div class="tax_title">¥税收</div>
            </div>
            <div class="tax_item">
              <div class="tax_num" style="color: #2effff; flex: 2">
                {{ Number(taxInfo.perTax).toFixed(2) || 0 }}
              </div>
              <div class="tax_title">¥亩均税收均值</div>
            </div>
          </div>
          <div class="tax_line">
            <div class="tax_icon">
              <img
                src="../../assets/satistics/icon-lastyear.png"
                alt=""
                class="tax_icon_img"
              />
              <span class="tax_icon_text">本年度</span>
            </div>
            <div class="tax_item">
              <div class="tax_num" style="color: #ffbf2e">
                {{ Number(taxInfo.yearOutput).toFixed(2) || 0 }}
              </div>
              <div class="tax_title">¥总产值</div>
            </div>
            <div class="tax_item">
              <div class="tax_num" style="color: #ffbf2e">
                {{ Number(taxInfo.yearTax).toFixed(2) || 0 }}
              </div>
              <div class="tax_title">¥税收</div>
            </div>
            <div class="tax_item" style="opacity: 0">
              <div class="tax_num" style="color: #ffbf2e; flex: 2">
                {{ Number(taxInfo.perTax).toFixed(2) || 0 }}
              </div>
              <div class="tax_title">¥亩均税收平均值</div>
            </div>
          </div>
        </div>
      </div>
      <div class="first_pad first_pad2" style="height: 30%">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <img
          src="../../assets/satistics/img-circle-back.png"
          alt=""
          class="circle_img"
        />
        <div class="pad_title">
          <span
            :class="[
              chosenTitle == 0
                ? 'pad_title_text selected_title'
                : 'pad_title_text',
            ]"
            @click="changeTitleType(0)"
            >资产占比分析</span
          >/<span
            :class="[
              chosenTitle == 1
                ? 'pad_title_text selected_title'
                : 'pad_title_text',
            ]"
            @click="changeTitleType(1)"
            >资源占比分析</span
          >
        </div>
        <ec-pie
          style="
            height: 70%;
            width: 95%;
            position: absolute;
            top: 20%;
            left: 0%;
          "
          :unit="[chosenTitle == 0 ? '(万元)' : '(亩)']"
          :data="propertyData3"
          type="环比"
        ></ec-pie>
      </div>
      <div class="first_pad first_pad2" style="height: 30%">
        <img
          src="../../assets/satistics/img-content-back.png"
          alt=""
          class="back_img"
        />
        <div class="pad_title">
          <span class="pad_title_text selected_title">关怀人群(人数)</span>
        </div>
        <div class="content_area">
          <div class="special_people">
            <img src="../../assets/bg5.png" alt="" class="special_people_img" />
            <div
              class="special_people_item"
              style="right: 82%; top: 55%; text-align: right"
            >
              <div class="special_people_num">{{ importPeopleNum[0] }}</div>
              <div class="special_people_name">{{ importPeopleNames[0] }}</div>
            </div>
            <div
              class="special_people_item"
              style="right: 82%; top: 75%; text-align: right"
            >
              <div class="special_people_num">{{ importPeopleNum[1] }}</div>
              <div class="special_people_name">{{ importPeopleNames[1] }}</div>
            </div>
            <div
              class="special_people_item"
              style="right: 82%; top: 35%; text-align: right"
            >
              <div class="special_people_num">{{ importPeopleNum[4] }}</div>
              <div class="special_people_name">{{ importPeopleNames[4] }}</div>
            </div>
            <div
              class="special_people_item"
              style="right: 82%; top: 10%; text-align: right"
            >
              <div class="special_people_num">{{ importPeopleNum[7] }}</div>
              <div class="special_people_name">{{ importPeopleNames[7] }}</div>
            </div>
            <div
              class="special_people_item"
              style="left: 78%; top: 55%; text-align: left"
            >
              <div class="special_people_num">{{ importPeopleNum[5] }}</div>
              <div class="special_people_name">{{ importPeopleNames[5] }}</div>
            </div>
            <div
              class="special_people_item"
              style="left: 78%; top: 35%; text-align: left"
            >
              <div class="special_people_num">{{ importPeopleNum[3] }}</div>
              <div class="special_people_name">{{ importPeopleNames[3] }}</div>
            </div>
            <div
              class="special_people_item"
              style="left: 78%; top: 10%; text-align: left"
            >
              <div class="special_people_num">{{ importPeopleNum[2] }}</div>
              <div class="special_people_name">{{ importPeopleNames[2] }}</div>
            </div>
            <div
              class="special_people_item"
              style="left: 78%; top: 75%; text-align: left"
            >
              <div class="special_people_num">{{ importPeopleNum[6] }}</div>
              <div class="special_people_name">{{ importPeopleNames[6] }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--    <div class="map_button" @click="showMap" v-show="!mapVisible">-->
    <!--      <img src="../../assets/satistics/icon-map.svg" alt="" class="map_icon" />-->
    <!--    </div>-->
    <div class="back_button" @click="hiddenMap" v-show="mapVisible">
      <img
        src="../../assets/satistics/icon-back-to-index.png"
        alt=""
        class="map_icon"
      />
    </div>

    <!--    <div class="float_right_pad">-->
    <!--      <div class="pad_info_item">-->
    <!--        <div class="pad_title">-->
    <!--          <span class="pad_title_text">男女比例</span>-->
    <!--        </div>-->
    <!--        <div class="pad_content">-->

    <!--        </div>-->
    <!--      </div>-->
    <!--    </div>-->
    <view-modal ref="viewModal"></view-modal>
  </div>
</template>

<script>
import { Carousel, CarouselItem, Select, Option } from "element-ui";
import Vue from "vue";
import ScreenMap from "@/components/map/screenMapInfoSec";

Vue.use(Carousel);
Vue.use(CarouselItem);
Vue.use(Select);
Vue.use(Option);

export default {
  name: "info",
  components: {
    ecPie: () => import("./components/ec-pie"),
    viewModal: () => import("./components/infoqyxcdetail.vue"),
    ScreenMap,
  },
  computed: {
    // orderType(type) {
    //   if (type == 1) return '出租房巡查'
    //   if (type == 2) return '9+1巡查'
    //   if (type == 3) return '出租房巡查'
    // }
  },
  data() {
    return {
      thisYear: new Date().getFullYear(),
      colorPad: [
        "rgba(255, 173, 0, 1)",
        "rgba(255, 55, 55, 1)",
        "rgba(111, 90, 255, 1)",
        "rgba(0, 250, 255, 1)",
      ],
      discribe:
        "灵峰村位于相城区北桥街道西北，北接常熟。西邻无锡。辖区面积6.9平方公里，在册村民5812人、农户1836户、企业150余家、登记外来人口7000余人。村党委下设农村党支部3个、锦峰工业园党支部1个、非公经济党支部6个，共有党员215人。村委会下设村民小组28个，村民代表120名。按照新农村总体规划，灵峰村在建设新集中居住区和老村庄整治改造的同时，2007年5月新建了灵峰村服务中心，2008年11月投入使用。村服务中心占地80余亩，总建筑面积3.63万平方米，总投资5000余万元，服务中心遵循“为民、利民、便民”的原则，规划理念新，建设起点高，配套设施全，设有灵峰公园、活动中心、文化娱乐、休闲广场、农贸市场、商业餐饮、医疗服务、教育培训、警务室、幼儿园、社区服务大厅等。近年来，灵峰村认真贯彻“生产发展、生活宽裕、乡风文明、村容整洁、管理民主”社会主义新农村建设方针，紧紧围绕“四城”建设目标，坚持科学发展、协调发展、持续发展、和谐发展、全面发展，村级经济和社会事业建设取得明显成效。先后获得“江苏省优秀基层党组织”、“江苏省文明村”、“江苏省依法治村示范村”、“江苏省民主管理示范村”、“苏州市新农村建设示范村”等荣誉称号。",
      mapVisible: false,
      propertyPage: 0,
      propertyData1: [
        {
          name: "流动资产",
          value: 196375878.76,
          rate: 30,
        },
        {
          name: "农业资产",
          value: 12899919.27,
          rate: -16,
        },
        {
          name: "长期资产",
          value: 6740000.0,
          rate: 5,
        },
        {
          name: "固定资产",
          value: 117993567.83,
          rate: -5,
        },
        {
          name: "其他资产",
          value: 1845790.35,
          rate: 12,
        },
      ],
      orderList: [[]],
      ordertabcolor: [
        "rgba(50,101,225, 0.5)",
        "rgba(201,139,23, 0.5)",
        "rgba(26,169,78, 0.5)",
      ],
      ordertablist: ["出租户巡查", "9+1场所巡查", "企业安全生产巡查"],
      checkType: null,
      statusType: null,
      propertyData2: [
        {
          name: "农用地面积",
          value: 3402.27,
          rate: 30,
        },
        {
          name: "建筑用地面积",
          value: 918.0,
          rate: -16,
        },
        { name: "未利用地面积", value: 0, rate: 0 },
      ],
      propertyData3: [],
      peopleNum: {
        partyMemberTotal: 0,
        peopleResidenceTotal: 0,
        zhuhuTotal: 0,
        dangzhibuNumber: 0,
      },
      importPeopleNum: [],
      activityData: [
        {
          name: "志愿者活动",
          value: 23,
          rate: "58.9%",
        },
        {
          name: "党员活动",
          value: 11,
          rate: "28.2%",
        },
        {
          name: "文艺活动",
          value: 2,
          rate: "5.1%",
        },
        {
          name: "其他活动",
          value: 3,
          rate: "7.6%",
        },
      ],
      activityRate: [
        {
          name: "志愿者活动",
          value: 23,
        },
        {
          name: "党员活动",
          value: 11,
        },
        {
          name: "文艺活动",
          value: 2,
        },
        {
          name: "其他活动",
          value: 3,
        },
      ],
      importPeopleNames: [],
      totalNum: 39,
      mapInfo: null,
      taxInfo: {
        lastOutput: 0,
        lastTax: 0,
        perTax: 0,
        yearOutput: 0,
        yearTax: 0,
      },
      rencentInfo: [
        {
          date: "2022.7.25 12:00",
          val: "在发展经济的同时，灵峰村大力发展社会事业，新建了社区医疗卫生服务站、幼儿园、600吨级生活污水处理厂等。",
        },
        {
          date: "2022.7.25 12:00",
          val: "在发展经济的同时，灵峰村大力发展社会事业，新建了社区医疗卫生服务站、幼儿园、600吨级生活污水处理厂等。",
        },
        {
          date: "2022.7.25 12:00",
          val: "在发展经济的同时，灵峰村大力发展社会事业，新建了社区医疗卫生服务站、幼儿园、600吨级生活污水处理厂等。",
        },
      ],
      chosenTitle: 0,
      amountInfo: [
        {
          name: "测试1",
          workNum: 10,
          memberNum: 20,
        },
        {
          name: "测试2",
          workNum: 10,
          memberNum: 20,
        },
        {
          name: "测试3",
          workNum: 10,
          memberNum: 20,
        },
        {
          name: "测试4",
          workNum: 10,
          memberNum: 20,
        },
        {
          name: "测试5",
          workNum: 10,
          memberNum: 20,
        },
      ],
      placeNum: {
        businessPlaceTotal: 0,
        companyTotal: 0,
        householdTotal: 0,
        temple: 0,
      },
      // 选中地图户主
      selectHouseData: [],
      lingfengInfo: {},
    };
  },
  // watch: {
  //   selectOwnerId(newVal, oldValue) {
  //     console.log(newVal, 'new')
  //     console.log(oldValue, 'old')
  //   }
  // },
  mounted() {
    Promise.all([
      this.getPeopleNum(),
      this.getPlaceNum(),
      this.initPeopleChart(),
      this.getTaxInfo(),
      this.getThreeOneData(),
      this.getCountAssets(),
      this.getSourceAssets(),
      // this.getLingfengData(),
    ]).catch((e) => console.log(e, "expcet"));
  },
  beforeDestroy() {},
  methods: {
    showMap() {
      // this.$router.replace('/map')
      this.mapVisible = true;
      this.initMapInfo();
      this.$emit("change", this.mapVisible);
    },
    hiddenMap() {
      this.mapVisible = false;
      this.$emit("change", this.mapVisible);
    },

    changeTitleType(index) {
      this.chosenTitle = index;
      if (index == 0) {
        this.propertyData3 = this.propertyData1;
      } else {
        this.propertyData3 = this.propertyData2;
      }
    },

    getPeopleNum() {
      this.$http.get("api/tPlatformOne/getMemberTotal").then((res) => {
        if (res.data.code == 200) {
          this.peopleNum = res.data.data;
        }
      });
    },
    getPlaceNum() {
      this.$http.get("api/tPlaceNumber/getPlaceNumberTotal").then((res) => {
        if (res.data.code == 200) {
          this.placeNum = res.data.data;
        }
      });
    },
    getTaxInfo() {
      let params = {
        companyId: 1,
      };
      this.$http
        .get("api/tCompanyCount/getCompanyCount", { params: params })
        .then((res) => {
          if (res.data.code == 200) {
            this.taxInfo = res.data.data;
          }
        });
    },
    getLingfengData() {
      this.$http.get("api/gis/peopleRate").then((res) => {
        this.lingfengInfo = res.data.data;
      });
    },
    getThreeOneData() {
      let url = "api/tPlatformOne/getThreeCheck";
      if (this.checkType || this.statusType || this.statusType == 0) {
        url += "?";
      }
      if (this.checkType) {
        url = url + "type=" + this.checkType;
      }
      if (!(!this.checkType || (!this.statusType && this.statusType != 0))) {
        url += "&";
      }
      if (this.statusType || this.statusType == 0) {
        url = url + "status=" + this.statusType;
      }
      let typeordertablist = ["出租户巡查", "9+1场所巡查", "企业安全生产巡查"];
      this.$http.get(url).then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          let listArr = [];
          let tmpArr = [];
          let indexcolor = -1;
          data.forEach((item, index) => {
            let items1 = item;
            let index1 = typeordertablist.findIndex(
              (info) => info === item.typeName
            );
            // if(index1==-1){
            // 	indexcolor++
            // 	this.ordertablist.push(item.typeName)
            // }
            items1["ordercolorindex"] = index1;
            tmpArr.push(items1);
            if (index == data.length - 1 || index % 4 == 3) {
              listArr.push(tmpArr);
              tmpArr = [];
            }
          });
          // console.log(listArr)
          this.orderList = listArr;
        }
      });
    },

    getMapData() {
      this.$http.get("api/gis/peopleRate").then((res) => {
        if (res.data.code == 200) {
          this.mapInfo = res.data.data;
        }
      });
    },

    initPeopleChart() {
      this.$http.get("api/tPlatformOne/getTKeypersonnelTotal").then((res) => {
        if (res.data.code == 200) {
          let namesObj = {
            emancipistPeopleTotal: "刑满释放",
            mentalPeopleTotal: "精神病人",
            lowIncomeTotal: "低保户",
            rectifyPeopleTotal: "矫正、安置帮教",
            severeDisabilityTotal: "重残家庭",
            careChildrenTotal: "困境儿童",
            careDisabilitiesTotal: "一户多残",
            fiveGuaranteesTotal: "五保户",
          };
          let nameArr = Object.getOwnPropertyNames(namesObj);
          let names = [];
          let values = [];
          nameArr.forEach((item) => {
            names.push(namesObj[item]);
            values.push(res.data.data[item]);
          });

          this.importPeopleNum = values;
          this.importPeopleNames = names;
        }
      });
    },
    getCountAssets() {
      this.$http.get("api/tCountAssets/getCountAssets").then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          data.forEach((item) => {
            item.value = Math.floor(parseFloat(item.value) / 100) / 100;
          });
          this.propertyData1 = data;
          this.propertyData3 = this.propertyData1;
        }
      });
    },
    getSourceAssets() {
      this.$http.get("api/tResourceAsset/getResourceAssetTotal").then((res) => {
        if (res.data.code == 200) {
          let data = res.data.data;
          this.propertyData2 = data;
        }
      });
    },
    queryFamilyData(id) {
      this.$http
        .get(`api/gis/listPeopleByResidenceNo?residenceNo=${id}`)
        .then((res) => {
          console.log(res, "res");
          this.selectHouseData = res.data.data;
        });
      console.log(id, "户主ID");
    },

    initMapInfo() {
      addEventListener("message", (e) => {
        let data = JSON.parse(e.data);
        if (data.type == "msg") {
          // 获取选中户主信息
          this.queryFamilyData(data.result);
        }
      });

      // 获取住户信息
      this.$http.get("api/gis/initPoint").then((res) => {
        console.log(res, "res");
        if (res.data.code == 200) {
          // 打点
          let posInfo = res.data.data;
          this.$refs.mapFrame.contentWindow.postMessage(
            JSON.stringify(posInfo),
            "*"
          );
        }
      });
    },
    handleView(row) {
      this.$refs.viewModal.modal = true;
      this.$refs.viewModal.getData(row);
    },
  },
};
</script>

<style scoped lang="less">
  @font-face {
    font-family: PingFang-Medium;
    src: url("~@/fonts/PingFang-Medium.ttf");
  }

  .screenMapBox{
    box-shadow: 0 100px 300px 0 rgba(0, 0, 0, 0.9);
  }

  .app-container {
    width: 100%;
    height: 100%;
    position: relative;
    box-sizing: border-box;

    .frame_page {
      position: relative;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: 0;
    }

    .frame_front {
      position: absolute;
      left: 0;
      top: -6.2rem;
      width: 100%;
      height: calc(100% + 6.2rem);
      background: linear-gradient(to bottom, rgba(22, 48, 106, 0.36) 0%, rgba(22, 48, 106, 0) 5%, rgba(22, 48, 106, 0) 95%, rgba(22, 48, 106, 0.36) 100%);
    }

    .people_echart {
      width: 100%;
      height: 100%;
      background: rgba(22, 48, 106, 0.36);
    }

    .left_pad {
      position: absolute;
      top: 8%;
      left: 0;
      background: linear-gradient(to right, rgba(22, 48, 106, 0.36) 0%, rgba(22, 48, 106, 0) 100%);
      height: 88%;
      width: 30%;
      padding: 0.6rem 1.2rem 1.5rem 1.2rem;
      z-index: 501;

      .card_pad {
        width: 100%;
        height: 40%;

        .card_img {
          width: 100%;
          height: 80%;

          .card_img_icon {
            height: 100%;
            width: 100%;
          }
        }

        .card_text {
          background: rgba(0, 25, 61, 0.65);
          padding: 0.4rem 1rem;
          font-size: 14px;
          font-weight: 400;
          color: #D5E6FF;
          line-height: 20px;

          span {
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }
      }

      .property_analysis {
        position: relative;
        width: 100%;
        height: 100%;


        .property_analysis_item {
          width: 100%;
          height: 49%;
          margin-bottom: 4px;
          padding: 0.4rem 0.8rem;
          background: rgba(29, 76, 153, 0.2);

          .property_title {
            display: flex;
            align-items: center;

            .property_title_text {
              font-size: 20px;
              font-weight: 500;
              color: #FFC52C;
              line-height: 26px;
            }

            .title_pattern {
              flex: 1;
              height: 8px;
              background: linear-gradient(to right,
              transparent 0.1%, transparent 2.5%, rgba(68, 122, 203, 0.001) 2.5%, rgba(68, 122, 203, 0.035) 3.5%, transparent 3.5%, transparent 6%, rgba(68, 122, 203, 0.035) 6%, rgba(68, 122, 203, 0.07) 7%, transparent 07%, transparent 9%, rgba(68, 122, 203, 0.07) 9%, rgba(68, 122, 203, 0.1) 10%,
              transparent 10.1%, transparent 12.5%, rgba(68, 122, 203, 0.101) 12.5%, rgba(68, 122, 203, 0.135) 13.5%, transparent 13.5%, transparent 16%, rgba(68, 122, 203, 0.135) 16%, rgba(68, 122, 203, 0.17) 17%, transparent 17%, transparent 19%, rgba(68, 122, 203, 0.17) 19%, rgba(68, 122, 203, 0.2) 20%,
              transparent 20.1%, transparent 22.5%, rgba(68, 122, 203, 0.201) 22.5%, rgba(68, 122, 203, 0.235) 23.5%, transparent 23.5%, transparent 26%, rgba(68, 122, 203, 0.235) 26%, rgba(68, 122, 203, 0.27) 27%, transparent 27%, transparent 29%, rgba(68, 122, 203, 0.27) 29%, rgba(68, 122, 203, 0.3) 30%,
              transparent 30.1%, transparent 32.5%, rgba(68, 122, 203, 0.301) 32.5%, rgba(68, 122, 203, 0.335) 33.5%, transparent 33.5%, transparent 36%, rgba(68, 122, 203, 0.335) 36%, rgba(68, 122, 203, 0.37) 37%, transparent 37%, transparent 39%, rgba(68, 122, 203, 0.37) 39%, rgba(68, 122, 203, 0.4) 40%,
              transparent 40.1%, transparent 42.5%, rgba(68, 122, 203, 0.401) 42.5%, rgba(68, 122, 203, 0.435) 43.5%, transparent 43.5%, transparent 46%, rgba(68, 122, 203, 0.435) 46%, rgba(68, 122, 203, 0.47) 47%, transparent 47%, transparent 49%, rgba(68, 122, 203, 0.47) 49%, rgba(68, 122, 203, 0.5) 50%,
              transparent 50.1%, transparent 52.5%, rgba(68, 122, 203, 0.501) 52.5%, rgba(68, 122, 203, 0.535) 53.5%, transparent 53.5%, transparent 56%, rgba(68, 122, 203, 0.535) 56%, rgba(68, 122, 203, 0.57) 57%, transparent 57%, transparent 59%, rgba(68, 122, 203, 0.57) 59%, rgba(68, 122, 203, 0.6) 60%,
              transparent 60.1%, transparent 62.5%, rgba(68, 122, 203, 0.601) 62.5%, rgba(68, 122, 203, 0.635) 63.5%, transparent 63.5%, transparent 66%, rgba(68, 122, 203, 0.635) 66%, rgba(68, 122, 203, 0.67) 67%, transparent 67%, transparent 69%, rgba(68, 122, 203, 0.67) 69%, rgba(68, 122, 203, 0.7) 70%,
              transparent 70.1%, transparent 72.5%, rgba(68, 122, 203, 0.701) 72.5%, rgba(68, 122, 203, 0.735) 73.5%, transparent 73.5%, transparent 76%, rgba(68, 122, 203, 0.735) 76%, rgba(68, 122, 203, 0.77) 77%, transparent 77%, transparent 79%, rgba(68, 122, 203, 0.77) 79%, rgba(68, 122, 203, 0.8) 80%,
              transparent 80.1%, transparent 82.5%, rgba(68, 122, 203, 0.801) 82.5%, rgba(68, 122, 203, 0.835) 83.5%, transparent 83.5%, transparent 86%, rgba(68, 122, 203, 0.835) 86%, rgba(68, 122, 203, 0.87) 87%, transparent 87%, transparent 89%, rgba(68, 122, 203, 0.87) 89%, rgba(68, 122, 203, 0.9) 90%,
              transparent 90.1%, transparent 92.5%, rgba(68, 122, 203, 0.901) 92.5%, rgba(68, 122, 203, 0.935) 93.5%, transparent 93.5%, transparent 95.5%, rgba(68, 122, 203, 0.935) 95.5%, rgba(68, 122, 203, 0.97) 96.5%, transparent 96.5%, transparent 99%, rgba(68, 122, 203, 0.97) 99%, rgba(68, 122, 203, 1) 100%);

            }
          }

        }


        .switch_button {
          position: absolute;
          right: 0.8rem;
          top: calc(-23px - 0.6rem);
          width: 45px;
          transform: translate(0, -50%);

          display: flex;
          align-items: center;
          justify-content: space-between;

          .icon_button {
            width: 48%;
            cursor: pointer;
          }
        }
      }

      .mapBox {
        height: 74%;
        width: 88%;
        margin: 0 30px;
        position: absolute;
        top: 20%;
        left: 0%;
        border: 3px solid #2A4CA0;
      }

    }

    .center_pad {
      position: absolute;
      top: 8%;
      left: 50%;
      transform: translate(-50%, 0);
      height: 90%;
      padding: 0.6rem 1.2rem 1.5rem 1.2rem;
      width: 40%;

      

      .people_num {
        position: relative;
        width: 100%;
        height: 100%;

        display: flex;
        justify-content: space-between;
        align-items: center;

        .people_num_item {
          width: 31%;
          height: 100%;
          background: linear-gradient(to bottom, rgba(3, 52, 114, 0.45) 0%, rgba(0, 56, 127, 0.1000) 100%);
          /*background: red;*/
          position: relative;

          .flex_pad {
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;


            .item_left_icon {
              width: 27%;
            }

            .item_right {
              width: 70%;
              padding-left: 0.8rem;

              .item_num {
                font-family: myDigib;
                font-size: 36px;
                font-weight: bold;
                color: #FFFFFF;
                line-height: 40px;
              }

              .item_text {
                font-size: 16px;
                font-weight: 400;
                color: #FFFFFF;
                line-height: 20px;
              }
            }
          }


          .nation_flag {
            position: absolute;
            top: 0;
            right: 0;
            width: 40%;
            height: 100%;
          }


        }

        .place_num_item {
          width: 23.5%;
          height: 100%;
          background: rgba(22, 48, 106, 0.36);
          position: relative;

          display: flex;
          flex-direction: column;
          justify-content: center;

          padding: 0.4rem 0rem 0.4rem 0.8rem;

          .item_num {
            font-family: myDigib;
            font-size: 30px;
            color: #FFFFFF;
            line-height: 37px;
          }

          .item_text {
            font-size: 14px;
            color: #FFFFFF;
            line-height: 20px;
          }

          .item_icon {

          }
        }
      }

      .activity_pad {
        position: relative;
        height: 100%;
        width: 100%;
        display: flex;
        justify-content: space-between;

        .activity_num {
          position: relative;
          width: 20%;
          height: 100%;
          background: rgba(13, 43, 89, 0.35);
          display: flex;
          flex-direction: column;
          justify-content: right;
          align-items: center;

          .item_num {
            font-family: myDigib;
            font-size: 32px;
            font-weight: bold;
            color: #FFFFFF;
            line-height: 34px;
          }

          .item_text {
            font-size: 16px;
            font-weight: 400;
            color: #DBE9FF;
            line-height: 22px;
          }

          .activity_icon {
            position: absolute;
            top: 0;
            right: 0;
            width: 85%;
          }
        }

        .activity_rate {
          width: 25%;
          height: 100%;
          background: rgba(13, 43, 89, 0.35);
          /*background: grey;*/
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          padding: 0.6rem 0.8rem;

          .rate_item {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .item_name {
              flex: 5;
              font-size: 14px;
              font-weight: 400;
              color: #DBE9FF;
              line-height: 20px;
            }

            .item_line {
              position: relative;
              flex: 3;
              height: 4px;
              background: rgba(20, 39, 69, 1);
              overflow: hidden;

              .item_line_front {
                position: absolute;
                top: 0;
                left: 0;
                height: 100%;
              }
            }

            .item_num {
              flex: 2;
              font-size: 14px;
              font-weight: 400;
              color: #FFAD00;
              line-height: 20px;
              text-align: right;
              margin-left: 0.2rem;
            }
          }
        }

        .activity_pie {
          width: 52%;
          height: 100%;
          display: flex;

          .pie_title {
            width: 44px;
            padding: 4px;
            height: 100%;
            font-size: 16px;
            color: #FFFFFF;
            line-height: 22px;
            letter-spacing: 2px;
            display: flex;
            align-items: center;
          }
        }

        .total_num {
          position: absolute;
          right: 1rem;
          top: calc(-23px - 0.6rem);
          transform: translate(0, -50%);
          display: flex;
          align-items: center;

          font-size: 16px;
          font-weight: 400;
          color: #DBE9FF;
          line-height: 22px;
        }
      }


      .list_item:nth-child(odd) {
        background: rgba(4, 49, 110, 0.65)
      }

      .list_item:nth-child(even) {
        background: rgba(7, 22, 41, 0.65)
      }

      .list_item {
        width: 100%;
        height: 50%;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: space-around;

        .list_item_type {
          text-align: center;
          // width: 18%;
          padding: 0 0.5rem;
          border: 1px solid;
        }

        .list_item_title {
          width: 65%;
          text-align: left;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }

        .list_item_status {
          width: 10%;
        }
      }

      .function_pad {
        position: absolute;
        right: 1.2rem;
        top: calc(-23px - 0.6rem);
        transform: translate(0, -50%);
        z-index: 200;

        .button_more {
          font-size: 14px;
          font-weight: 400;
          color: #00F7FF;
          line-height: 20px;
          cursor: pointer;
        }
      }
    }

    .right_pad {
      position: absolute;
      top: 8%;
      right: 0;
      background: linear-gradient(to left, rgba(22, 48, 106, 0.36) 0%, rgba(22, 48, 106, 0) 90%);
      height: 88%;
      padding: 0.6rem 1.2rem 1.5rem 1.2rem;
      width: 30%;
      z-index: 500;
      .tax_line {
        height: 45%;
        margin: 2% 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: linear-gradient(270deg, rgba(0, 26, 75, 0.5) 0%, rgba(1, 28, 92, 0.5) 100%);

        .tax_icon {
          width: 110px;
          position: relative;

          .tax_icon_img {
            width: 100%;
          }

          .tax_icon_text {
            position: absolute;
            width: 85px;
            text-align: center;
            top: 48%;
            left: 50%;
            transform: translate(-50%, -50%);
            font-size: 14px;
            font-weight: 500;
            color: #DBE9FF;
            line-height: 20px;
          }
        }

        .tax_item {
          flex: 1;
          overflow: hidden;
          padding: 0 1.2rem;

          .tax_num {
            font-size: 17px;
            font-weight: bold;
            line-height: 30px;
          }

          .tax_title {
            font-size: 14px;
            font-weight: 400;
            color: #DBE9FF;
            line-height: 20px;
            white-space: nowrap;
          }
        }
      }

      .special_people {
        position: relative;
        width: 100%;
        height: 100%;

        .special_people_img {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          width: 52%;
        }

        .special_people_item {
          position: absolute;

          .special_people_num {
            color: #31CEFF;
            font-size: 20px;
            font-weight: bold;
            color: #31CEFF;
            line-height: 14px;
          }

          .special_people_name {
            min-width: 70px;
            font-size: 14px;
            font-weight: 400;
            color: #DBE9FF;
            font-family: PingFang-Medium;
          }
        }

      }

    }

    .first_pad {
      position: relative;
      width: 100%;
      margin: 1.8rem 0;
      // background-color: #15317d;
      background-color: rgba(14, 30, 79, 0.7);
      
      // border-radius: 40px;
      .float_num {
        position: absolute;
        top: 10%;
        width: 100%;
        // height: 100%;
        display: flex;
        flex-wrap: wrap;
        padding-left: 4%;
        .float_num_item {
          // position: absolute;
          // text-align: center;
          display: flex;
          width: 32%;
          margin-top: 10px;
          .float_num_text {
            font-size: 20px;
            font-weight: bold;
            line-height: 25px;
          }

          .float_num_icon {
            width: 70px;
            // height: 38%;
          }

          .float_num_title {
            // width: 110px;
            // text-align: center;
            font-size: 18px;
            font-weight: 400;
            color: #DBE9FF;
            line-height: 25px;
          }
        }
      }

      .float_num1 {
        position: absolute;
        top: 60%;
        width: 100%;
        // height: 100%;
        display: flex;
        padding-left: 4%;
        .float_num_item {
          text-align: center;
          // position: absolute;
          // text-align: center;
          // display: flex;
          width: 48%;
          .float_num_text {
            font-size: 20px;
            font-weight: bold;
            line-height: 15px;
          }

          .float_num_icon {
            width: 70px;
            // height: 38%;
          }

          .float_num_title {
            // width: 110px;
            // text-align: center;
            font-size: 18px;
            font-weight: 400;
            color: #DBE9FF;
            line-height: 25px;
          }
        }
      }

      .pad_title {
        position: absolute;
        left: 5%;
        top: 5%;
        font-size: 20px;
        color: rgba(73, 169, 255, 1);
        user-select: none;

        .pad_title_text {
          margin: 0 0.8rem;
          cursor: pointer;
        }

        .selected_title {
          font-size: 26px;
          color: #FFFFFF;
          font-family: myTitle;
        }
      }

      .pad_title1{
        position: absolute;
        left: 5%;
        top: 51%;
        font-size: 20px;
        color: rgba(73, 169, 255, 1);
        user-select: none;

        .pad_title_text {
          margin: 0 0.8rem;
          cursor: pointer;
        }

        .selected_title {
          font-size: 26px;
          color: #FFFFFF;
          font-family: myTitle;
        }
      }

      .content_area {
        position: absolute;
        top: 15%;
        left: 50%;
        transform: translate(-50%, 0);
        width: 90%;
        height: 80%;


      }

      .top_right {
        position: absolute;
        right: 5%;
        top: 6%;
      }

      .more_button {
        font-size: 14px;
        color: rgba(0, 247, 255, 1);
        user-select: none;
        cursor: pointer;
      }


      .back_img {
        width: 100%;
        height: 100%;
      }

      .circle_img {
        position: absolute;
        left: 15.5%;
        top: 55%;
        transform: translate(0, -50%);
        width: 40%;
      }

      .gd_list_item {
        // display: flex;
        // justify-content: space-between;
        // align-items: center;
        margin: 0.6rem 0.4rem;
        padding: 0.8rem 0.5rem 0.3rem 0.5rem;
        background: rgba(4, 49, 110, 0.4);
        box-sizing: border-box;
        cursor: pointer;

        .gd_list_item_line {
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 0.5rem;
          box-sizing: border-box;

          .gd_list_item_type {
            width: 60%;
            // padding: 4px;
            color: #ffffff;
            // text-align: center;
            span {
              background: rgba(50, 101, 225, 0.5);
              border-radius: 5px;
              color: #ffffff;
              padding: 0.2rem 0.4rem;
            }

            // border: 1px solid rgba(49, 206, 255, 1);
            // color: rgba(49, 206, 255, 1);
          }

          .gd_list_item_time {
            color: #ffffff;
            text-align: right;
          }
        }

        .gd_list_item_content {
          display: flex;
          align-items: center;
          justify-content: space-between;
          box-sizing: border-box;

          .gd_list_item_title {
            // width:100%;
            text-align: left;
            color: white;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            // display: -webkit-box;
            // -webkit-line-clamp: 3;
            // -webkit-box-orient: vertical;
            // overflow: hidden;
            // text-overflow: ellipsis;
          }

          .gd_list_item_status {
            font-size: 14px;
            width: 60px;
            text-align: right;
          }
        }
      }
    }

    .first_pad2 {
      margin: 1rem 0 !important;

      .circle_img {
        position: absolute;
        left: 18.7%;
        top: 55%;
        transform: translate(0, -50%);
        width: 28%;
      }
    }

    .arrow_border_pad {
      position: absolute;
      top: 0;
      left: 0;
      z-index: 10;
      width: 100%;
      height: 100%;
      background: linear-gradient(to bottom, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left top no-repeat,
      linear-gradient(to right, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left top no-repeat,
      linear-gradient(to bottom, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right top no-repeat,
      linear-gradient(to left, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right top no-repeat,
      linear-gradient(to top, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left bottom no-repeat,
      linear-gradient(to right, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) left bottom no-repeat,
      linear-gradient(to top, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right bottom no-repeat,
      linear-gradient(to left, #0595F9 0px, #0595F9 2px, transparent 3px, transparent 100%) right bottom no-repeat;
      background-size: 10px 10px;
    }

    .map_button {
      position: absolute;
      right: 4rem;
      bottom: 1.6rem;
      width: 70px;
      z-index: 500;
      /*background: red;*/
      display: flex;
      align-items: center;
      /*border-radius: 4px 4px 15px 15px;*/
      /*background: linear-gradient(to right, rgba(28, 108, 190, 1), rgba(8, 152, 219, 1));*/
      /*padding: 0.2rem 0.6rem;*/
      cursor: pointer;
      user-select: none;

      .map_icon {
        width: 100%;

      }

      .map_text {
        flex: 1;
        font-size: 20px;
        margin: 0 6px;
        color: #fff;
      }

      .map_icon_right {
        width: 15%;
      }
    }

    .back_button {
      position: absolute;
      right: 4rem;
      top: 6.8rem;
      width: 70px;
      z-index: 500;
      /*background: red;*/
      display: flex;
      align-items: center;
      /*border-radius: 4px 4px 15px 15px;*/
      /*background: linear-gradient(to right, rgba(28, 108, 190, 1), rgba(8, 152, 219, 1));*/
      /*padding: 0.2rem 0.6rem;*/
      cursor: pointer;
      user-select: none;

      .map_icon {
        width: 100%;

      }

      .map_text {
        flex: 1;
        font-size: 20px;
        margin: 0 6px;
        color: #fff;
      }

      .map_icon_right {
        width: 15%;
      }
    }

    .float_right_pad {
      width: 20%;
      min-width: 300px;
      height: 60%;
      position: absolute;
      top: 40%;
      right: 0;
      transform: translate(0, -50%);
      background: pink;
      
      .pad_info_item {
        width: 100%;

        .pad_title {
          z-index: 100;

          .pad_title_text {
            position: relative;
            left: 40%;
            bottom: -10px;
            font-size: 16px;
            font-weight: 500;
            padding: 4px 16px;
            border-radius: 20px;
            background: #17233d;
            color: white;


          }
        }

        .pad_content {
          position: relative;
          width: 90%;
          margin: 0 auto;
          padding: 16px 32px;
          background: rgba(22, 40, 72, 0.85);
          border: 2px solid #00C0cc;
        }
      }
    }
  }


  .xalachoose {
    background: rgba(59, 92, 147, 1);
    margin-right: 0.8rem;
  }

  /deep/ .el-input__inner {
    background: #0E235D !important;
    color: #2ECDFF;
    width: 8.3rem;
    height: 1.8rem;
    line-height: 1.8rem;
    border: 1px solid #587CA0;
  }

  /deep/ .el-input__icon {
    line-height: 1.8rem;
  }

  /deep/ .el-select-dropdown {
    background: rgba(40, 82, 163, 0.7);
    border: 1px solid #1060A8;
    z-index: 200;
  }

  /deep/ .el-input__prefix, /deep/ .el-input__suffix {
    color: #587CA0;
  }

  /*// select选择器*/
  .el-select-dropdown__item.hover,
  .el-select-dropdown__item:hover {
    background-color: rgba(20, 44, 82, 0.8);
  }

  /deep/ .el-popper[x-placement^=bottom] .popper__arrow:after {
    border-bottom-color: rgba(40, 82, 163, 0.7);
  }

  /deep/ .el-select-dropdown__item.selected {
    color: #2ECDFF;
  }

  .el-select-dropdown__item {
    color: #FFFFFF;
  }
</style>
